export default "/fonts/line-awesome.woff?58df7918b614b748dd5715159ffc8c65";